import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { provideStates } from '@ngxs/store';

import { GoalStatusFlowService } from './goal-status-flow.service';
import { GoalStatusFlowState } from './goal-status-flow.state';

export function provideGoalStatusFlow(): (Provider | EnvironmentProviders)[] {
  return [
    provideStates([GoalStatusFlowState]),
    provideAppInitializer(() => {
      const service = inject(GoalStatusFlowService);
      service.init();
    }),
  ];
}
